import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/dashboard/quality/')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/quality/$canvasId',
      params: { canvasId: 'summary' },
    });
  },
});
